import styled from "styled-components";
import {flexFixedSizeItem} from "../../themes/architecture/css-helpers/flex";
import {MOBILE_HORIZONTAL_SPACE_BETWEEN_ITEMS, PC_HORIZONTAL_SPACE_BETWEEN_ITEMS} from "../space-between-items-consts";

export const BlankHorizontalSeparatorBox = styled.span<{multiplier?: number}>`
    ${flexFixedSizeItem}
    width: ${props => PC_HORIZONTAL_SPACE_BETWEEN_ITEMS(props.multiplier ?? 1)};
    @media ${props => props.theme.mediaQuery.lAndBelow} {
        width: ${props => MOBILE_HORIZONTAL_SPACE_BETWEEN_ITEMS(props.multiplier ?? 1)};
    }
`;
